import React, { Component } from 'react';
import { Card, Typography, Stack, Box, Icon } from '@mui/material';
import WithRouter from '../Layout/Router/WithRouter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class PageNavigationCard extends Component {
  render() {
    const { subPage, id, url, header, cardClass } = this.props;
    return (
      <Card
        className={`myOdu__pageNavigationCard ${cardClass}`}
        elevation="0"
        onClick={() =>
          subPage.externalUrl
            ? window.open(subPage.externalUrl, '_blank')
            : this.props.navigate(`/${url}/${subPage.page}`)
        }
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            subPage.externalUrl
              ? window.open(subPage.externalUrl, '_blank')
              : this.props.navigate(`/${url}/${subPage.page}`);
          }
        }}
        id={`card_${id}_${subPage.page}`}
        role="button"
        aria-pressed="false"
        tabIndex={0}
      >
        <Stack direction="row" justify-content="flex-start" alignItems="flex-start" spacing={2}>
          {subPage.icon && (
            <div className="icon">
              {typeof subPage.icon === 'string' ? (
                <img className="logo" src={subPage.icon} alt="" />
              ) : (
                <FontAwesomeIcon icon={subPage.icon} size="xl" />
              )}
            </div>
          )}
          <Stack justify-content="flex-start">
            <Typography component={header}>{subPage.title}</Typography>
            <Typography variant="p" align="left">
              {subPage.description}
            </Typography>
          </Stack>
        </Stack>
      </Card>
    );
  }
}

export default WithRouter(PageNavigationCard);
